import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Restoration from "./sections/Restoration";
import Protection from "./sections/Protection";
import Services from "./sections/Services";
import Impact from "./sections/Impact";
import VisualProof from "./sections/VisualProof";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Restoration />
      <Protection />
      <Services />
      <Impact />
      <VisualProof />
      <Testimonials />
      <Footer />
    </div>;
}